import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../components/pageLoader";
import Toast from "../../components/toast";
import ToastContainer from "../../components/toastContainer";
import { getArtists } from "../../api/artistApi";

const ArtistsPage = () => {
  const navigate = useNavigate();

  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  const fetchArtists = async () => {
    try {
      setLoading(true);
      const data = await getArtists();
      const list = Array.isArray(data) ? data : data.results || [];
      setArtists(list);
    } catch (err) {
      setToast({
        type: "error",
        message: err?.response?.data?.detail || "Failed to load artists",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArtists();
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-white">Artists</h1>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {artists.map((artist) => (
          <div
            key={artist.id}
            className="bg-slate-900/60 border border-white/10 rounded-xl p-4 flex flex-col"
          >
            {/* Image */}
            <div className="w-full h-40 bg-slate-800 rounded-lg flex items-center justify-center mb-4 overflow-hidden">
              {artist.profile_picture ? (
                <img
                  src={artist.profile_picture}
                  alt={artist.stage_name}
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-slate-500 text-sm">No Image</span>
              )}
            </div>

            {/* Info */}
            <div className="flex-1 space-y-1">
              <p className="text-white font-medium">
                {artist.stage_name || "-"}
              </p>
              <p className="text-slate-400 text-sm">
                {artist.real_name || "-"}
              </p>

              <div className="text-sm text-slate-400 mt-2 space-y-1">
                <p>
                  Active Bookings:{" "}
                  <span className="text-white">
                    {artist.active_bookings_count ?? 0}
                  </span>
                </p>
                <p>
                  Next Booking:{" "}
                  <span className="text-white">
                    {artist.next_booking_date || "-"}
                  </span>
                </p>
              </div>
            </div>

            {/* Action */}
            <button
              onClick={() => navigate(`/artists/${artist.id}`)}
              className="mt-4 px-3 py-2 rounded-lg text-sm text-white bg-slate-800 hover:bg-slate-700 transition"
            >
              View Profile
            </button>
          </div>
        ))}

        {!artists.length && (
          <div className="col-span-full text-center text-slate-400 py-10">
            No artists found
          </div>
        )}
      </div>

      {/* Toast */}
      <ToastContainer>
        {toast && (
          <Toast
            type={toast.type}
            message={toast.message}
            onClose={() => setToast(null)}
          />
        )}
      </ToastContainer>
    </div>
  );
};

export default ArtistsPage;
